import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfirmacaoComponent } from '@components/dialog-confirmacao/dialog-confirmacao.component';

import { CampoRelatorioPreenchimento } from '../../models/campo-relatorio-preenchimento';

@Component({
  selector: 'app-campos-relatorio-vistoria',
  standalone: false,
  templateUrl: './campos-relatorio-vistoria.component.html',
  styleUrl: './campos-relatorio-vistoria.component.scss'
})
export class CamposRelatorioVistoriaComponent {

  @Input() campos: CampoRelatorioPreenchimento[] = [];
  @Input() mostrarTag = false;

  constructor(private dialog: MatDialog) { }

  public adicionarCampo(): void {
    this.campos.push({ id: 0, nome: '', tagHtmlPdf: null, valor: '' });
  }

  public confirmarRemocao(campo: CampoRelatorioPreenchimento): void {
    const dialogRef = this.dialog.open(DialogConfirmacaoComponent, {
      width: '467px',
      panelClass: 'no-padding-dialog',
      disableClose: true,
    });
    dialogRef.componentInstance.titulo = 'Remover campo';
    dialogRef.componentInstance.mensagem = `O campo "${campo.nome || '-'}" será removido.`;
    dialogRef.componentInstance.textoBtnConfirmacao = 'Remover';
    dialogRef.componentInstance.btnBackgroundColor = '#F44336';
    dialogRef.componentInstance.acaoConfirmacao = () => this.removerCampo(campo);
  }

  private removerCampo(campo: CampoRelatorioPreenchimento): void {
    this.campos.splice(this.campos.indexOf(campo), 1);
  }
}
